const routes = [
    {
      path: '/supplier/contracts/dashboard',
      name: 'SupplierContractsDashboard',
      component: () => import('../views/supplier/contracts/dashboard/Dashboard.vue')
    },
    {
        path: '/supplier/contracts',
        name: 'SupplierContractsAuthoring',
        component: () => import('../views/supplier/contracts/Contracts.vue')
    },
    {
      path: '/supplier/contracts/:contractId/view',
      name: 'SupplierContractsView',
      component: () => import('../views/supplier/contracts/Contract.vue')
    },
    {
      path: '/supplier/contracts/:contractId/update',
      name: 'SupplierContractsUpdate',
      component: () => import('../views/supplier/contracts/UpdateContract.vue')
    },
    {
      path: '/tendersure/contracts/dashboard',
      name: 'QedContractsDashboard',
      component: () => import('../views/qed/contracts/dashboard/Dashboard.vue')
    },
    {
      path: '/tendersure/contracts/buyer',
      name: 'QedContractsAuthorBuyers',
      component: () => import('../views/qed/contracts/buyer/Buyers.vue')
    },
    {
      path: '/tendersure/contracts/buyer/:buyerId/contracts',
      name: 'QedContractsAuthorBuyerContracts',
      component: () => import('../views/qed/contracts/buyer/Contracts.vue')
    },
    {
      path: '/tendersure/contracts/buyer/:buyerId/contracts/:contractId',
      name: 'QedContractsAuthorBuyerContract',
      component: () => import('../views/qed/contracts/buyer/Contract.vue')
    },
    {
      path: '/tendersure/contracts/buyer/:buyerId/jobs',
      name: 'QedContractsAuthorBuyerJobs',
      component: () => import('../views/qed/contracts/buyer/Jobs.vue')
    },
    {
      path: '/tendersure/contracts/buyer/contract/:contractId/update',
      name: 'QedContractsAuthorBuyerUpdate',
      component: () => import('../views/qed/contracts/buyer/UpdateContract.vue')
    },
    {
      path: '/tendersure/contracts/buyer/contract/create',
      name: 'QedContractsAuthorBuyerCreate',
      component: () => import('../views/qed/contracts/buyer/CreateContract.vue')
    },
    {
      path: '/tendersure/contracts/sections',
      name: 'QedContractsTemplatesSections',
      component: () => import('../views/qed/contracts/sections/Sections.vue')
    },
    {
      path: '/tendersure/contracts/sections/:sectionId/view',
      name: 'QedContractsTemplatesSection',
      component: () => import('../views/qed/contracts/sections/Section.vue')
    },
    {
      path: '/tendersure/contracts/sections/create',
      name: 'QedContractsTemplatesSectionsCreate',
      component: () => import('../views/qed/contracts/sections/CreateSection.vue')
    },
    {
      path: '/tendersure/contracts/sections/:sectionId/update',
      name: 'QedContractsTemplatesSectionsUpdate',
      component: () => import('../views/qed/contracts/sections/UpdateSection.vue')
    },
    {
      path: '/tendersure/contracts/templates',
      name: 'QedContractsTemplatesTemplates',
      component: () => import('../views/qed/contracts/templates/Templates.vue')
    },
    {
      path: '/tendersure/contracts/templates/:templateId/view',
      name: 'QedContractsTemplatesTemplate',
      component: () => import('../views/qed/contracts/templates/Template.vue')
    },
    {
      path: '/tendersure/contracts/templates/:templateId/update',
      name: 'QedContractsTemplatesTemplatesUpdate',
      component: () => import('../views/qed/contracts/templates/UpdateTemplate.vue')
    },
    {
      path: '/tendersure/contracts/templates/create',
      name: 'QedContractsTemplatesTemplatesCreate',
      component: () => import('../views/qed/contracts/templates/CreateTemplate.vue')
    },
    {
      path: '/buyer/contracts/dashboard',
      name: 'BuyerContractsDashboard',
      component: () => import('../views/company/contracts/dashboard/Dashboard.vue')
    },
    {
      path: '/buyer/contracts/sections',
      name: 'BuyerContractsTemplatesSections',
      component: () => import('../views/company/contracts/sections/Sections.vue')
    },
    {
      path: '/buyer/contracts/sections/:sectionId/view',
      name: 'BuyerContractsTemplatesSection',
      component: () => import('../views/company/contracts/sections/Section.vue')
    },
    {
      path: '/buyer/contracts/sections/create',
      name: 'BuyerContractsTemplatesSectionsCreate',
      component: () => import('../views/company/contracts/sections/CreateSection.vue')
    },
    {
      path: '/buyer/contracts/sections/:sectionId/update',
      name: 'BuyerContractsTemplatesSectionsUpdate',
      component: () => import('../views/company/contracts/sections/UpdateSection.vue')
    },
    {
      path: '/buyer/contracts/templates',
      name: 'BuyerContractsTemplatesTemplates',
      component: () => import('../views/company/contracts/templates/Templates.vue')
    },
    {
      path: '/buyer/contracts/templates/:templateId/view',
      name: 'BuyerContractsTemplatesTemplate',
      component: () => import('../views/company/contracts/templates/Template.vue')
    },
    {
      path: '/buyer/contracts/templates/:templateId/update',
      name: 'BuyerContractsTemplatesTemplatesUpdate',
      component: () => import('../views/company/contracts/templates/UpdateTemplate.vue')
    },
    {
      path: '/buyer/contracts/templates/create',
      name: 'BuyerContractsTemplatesTemplatesCreate',
      component: () => import('../views/company/contracts/templates/CreateTemplate.vue')
    },
    {
      path: '/buyer/contracts/qed',
      name: 'BuyerContractsQed',
      component: () => import('../views/company/contracts/qed/Contracts.vue')
    },
    {
      path: '/buyer/contracts/qed/:contractId/update',
      name: 'BuyerContractsQedUpdate',
      component: () => import('../views/company/contracts/qed/UpdateContract.vue')
    },
    {
      path: '/buyer/contracts/supplier/jobs',
      name: 'BuyerContractsSupplierJobs',
      component: () => import('../views/company/contracts/supplier/Jobs.vue')
    },
    {
      path: '/buyer/contracts/supplier/jobs/:jobId/:sourcing_activity/categories',
      name: 'BuyerContractsSupplierCategories',
      component: () => import('../views/company/contracts/supplier/Categories.vue')
    },
    {
      path: '/buyer/contracts/supplier/:sourcing_activity/categories/:categoryId/contracts',
      name: 'BuyerContractsSupplierCategoryContracts',
      component: () => import('../views/company/contracts/supplier/Contracts.vue')
    },
    {
      path: '/buyer/contracts/supplier/contract/:contractId/view',
      name: 'BuyerContractsSupplierView',
      component: () => import('../views/company/contracts/supplier/Contract.vue')
    },
    {
      path: '/buyer/contracts/supplier/contract/:contractId/approve',
      name: 'BuyerContractsSupplierApprove',
      component: () => import('../views/company/contracts/supplier/ApproveContract.vue')
    },
    {
      path: '/buyer/contracts/supplier/categories/:categoryId/suppliers',
      name: 'BuyerContractsSupplierCategorySuppliers',
      component: () => import('../views/company/contracts/supplier/Suppliers.vue')
    },
    {
      path: '/buyer/contracts/supplier/contract/create',
      name: 'BuyerContractsSupplierCreate',
      component: () => import('../views/company/contracts/supplier/CreateContract.vue')
    },
    {
      path: '/buyer/contracts/supplier/contract/:contractId/update',
      name: 'BuyerContractsSupplierUpdate',
      component: () => import('../views/company/contracts/supplier/UpdateContract.vue')
    },
]

export default routes;
